var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomHandshake = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.806 13.762c-1.445-1.524-7.584-1.905-9.57-2.095-.18 0-.361 0-.542.19-.18.19-.36.572-.36.762v17.143c0 .571.36.952.902.952h5.417c.36 0 .722-.19.903-.571 0-.572 3.25-10.667 3.61-15.62 0-.19 0-.57-.36-.761z",
    fill: "#1E2969",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.125 18.333c-1.806-.571-3.43-1.333-4.875-1.904-3.25-1.524-4.694-.762-7.583 2.285-1.264 1.334-2.167 3.238-1.986 4 0 .19 0 .19.36.381.903.381 2.167.572 3.431-1.524.18-.19.361-.38.722-.38.542 0 .723-.191 1.264-.382.361-.19.722-.38 1.264-.57h.361c.18 0 .542.19.722.19.903.952 2.528 2.285 4.153 3.81 2.528 2.094 5.056 4.38 6.32 6.094h.18c-1.264-3.81-3.43-10.285-4.333-12z",
    fill: "#9A5238",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.764 13.571c-7.042 0-11.014 1.905-11.195 1.905l-.541.572c0 .19 0 .571.18.762 1.084 1.904 4.695 12.38 5.236 15.047.18.381.542.762.903.762h5.417c.542 0 .903-.381.903-.953V14.524c0-.572-.361-.953-.903-.953z",
    fill: "#1E2969",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.014 32.238c-.722-1.714-3.792-4.19-6.5-6.476-1.445-1.333-2.889-2.476-3.972-3.429-.18.19-.542.19-.542.381-.542.19-.722.381-1.444.381C22.11 25 20.306 25.762 18.319 25c-.902-.19-1.444-.952-1.625-1.714-.36-1.905 1.264-4.572 2.528-5.905h-3.61c-.723 3.81-1.987 8.762-2.89 11.429.722.761 1.445 1.714 1.986 2.095 3.43 3.047 7.403 6.095 8.125 6.666.542.381 1.625.762 2.167.762h.542l-2.89-3.047a.956.956 0 0 1 0-1.334c.362-.38.904-.38 1.265 0l3.61 3.81c.362.38.723.19 1.084.19.542-.19.722-.571.903-1.142l-4.153-4.381a.956.956 0 0 1 0-1.334c.361-.38.903-.38 1.264 0l4.514 4.762c.18.19.903.19 1.444 0 .18-.19.542-.38.723-.762l-5.056-5.333a.956.956 0 0 1 0-1.333c.361-.381.903-.381 1.264 0l5.236 5.523c.361.19.722 0 1.083-.19.18-.19.542-.762.18-1.524z",
    fill: "#9A5238",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomHandshake);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-handshake.10ace37b3e2ad5ee13c5e9857e090cb5.svg";